import React from "react";

import * as Styled from "./styles.js";

export default class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fromText: "", bodyText: "" };
  }

  render() {
    const closePopup = (props) => {
      this.props.closePopup();
    };

    const sendMsg = async (props) => {
      const requestOptions = {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          from: this.state.fromText, // Using raw data from user, we may want to validate this (e.g. format: xyz@something.com)
          body: this.state.bodyText, // Using raw data from user, we may want to validate this (e.g. length > 0)
        }),
      };
      await fetch("http://64.23.182.142/rest/v1/email", requestOptions); // TODO: Update this URL when domain changes
    };

    const fromDidChange = (event) => {
      this.setState({ fromText: event.target.value });
    };
    const bodyDidChange = (event) => {
      this.setState({ bodyText: event.target.value });
    };

    return (
      <Styled.Container className={this.props.className}>
        <Styled.Background onClick={closePopup} />
        <Styled.ContactPage>
          <Styled.ContactHeader>New Message</Styled.ContactHeader>
          <Styled.ContactSubText>TO</Styled.ContactSubText>
          <Styled.ContactTextBox
            type="text"
            value="contact@sterrio.com"
            disabled="disabled"
          />
          <Styled.ContactSubText>FROM</Styled.ContactSubText>
          <Styled.ContactTextBox
            value={this.state.toText}
            onChange={fromDidChange}
            type="text"
            placeholder="you@email.com"
          />
          <Styled.ContactSubText>BODY</Styled.ContactSubText>
          <Styled.ContactBody
            value={this.state.bodyText}
            onChange={bodyDidChange}
            maxLength="600"
            type="text"
            placeholder="Your message"
          />
          <Styled.ContactCounter>
            {600 - this.state.bodyText.length}/600
          </Styled.ContactCounter>
          <Styled.Buttons>
            <Styled.ButtonCancel onClick={closePopup}>
              {" "}
              Cancel{" "}
            </Styled.ButtonCancel>
            <Styled.ButtonSend onClick={sendMsg} cta>
              {" "}
              Send{" "}
            </Styled.ButtonSend>
          </Styled.Buttons>
        </Styled.ContactPage>
      </Styled.Container>
    );
  }
}
